<template>
  <div class="app-audio">
    <audio id="media" :src="aUrl" controls></audio>
  </div>
</template>

<script>

export default {
  name: 'AudioPath',
  data() {
    return {
      aId: '', //音频名称
      aUrl: '',
      am: '', //音频模块
      aSubM: '',//音频字路径
    }
  },
  mounted() {
    this.aId = this.$route.params.aId
    this.am = this.$route.params.am || 'am'
    this.aSubM = this.$route.params.aSubM || 'aSubM'
    this.aUrl = this.getAudioObj()
  },
  methods: {
    getAudioObj() {
      const id = this.aId
      return 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/content/prod/audio/' + this.am + '/' + this.aSubM + '/' + id + '.mp3'
    },
  },
}
</script>

<style scoped>
.app-audio {
  display: flex;
  align-items: center;
  height: 100%;
}

.app-audio audio {
  width: 100%;
  display: block;
}
</style>./AudioPath.vue



// WEBPACK FOOTER //
// src/pages/AudioPath.vue